<template>
  <div>
    <div v-if="model.id == undefined">
      <b-tabs>
        <b-tab :title="$t('message.Общие')" active>
          <b-form-group label="Username:" label-for="Username">
            <b-form-input
              id="Username"
              type="text"
              v-model="model.username"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Password:" label-for="Password">
            <b-form-input
              id="Password"
              type="password"
              v-model="model.password"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Enabled:" label-for="Enabled">
            <b-form-checkbox-group v-model="model.enabled" id="Enabled">
              <b-form-checkbox value="true"></b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group :label="$t('message.Роли') + ':'" label-for="Roles">
            <v-select
              multiple
              v-model="model.roles"
              :options="this.roles"
              label="name"
            ></v-select>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('message.Контакты')">
          <b-form-group label="Name:" label-for="Contact_name">
            <b-form-input
              id="Contact_name"
              type="text"
              v-model="model.name"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Email:" label-for="Contact_email">
            <b-form-input
              id="Contact_email"
              type="text"
              v-model="model.email"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Phone:" label-for="Contact_phone">
            <b-form-input
              id="Contact_phone"
              type="text"
              v-model="model.phone"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Address:" label-for="Contact_Address">
            <b-form-input
              id="Contact_address"
              type="text"
              v-model="model.address"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="url:" label-for="Contact_url">
            <b-form-input
              id="Contact_url"
              type="text"
              v-model="model.url"
              required
            >
            </b-form-input>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </div>
    <div v-if="model.id">
      <b-tabs>
        <b-tab :title="$t('message.Общие')" active>
          <b-form-group label="Username:" label-for="Username">
            <b-form-input
              id="Username"
              type="text"
              v-model="model.username"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Enabled:" label-for="Enabled">
            <b-form-checkbox-group v-model="model.enabled" id="Enabled">
              <b-form-checkbox value="true"></b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group :label="$t('message.Роли') + ':'" label-for="Roles">
            <v-select
              multiple
              v-model="model.roles"
              :options="this.roles"
              label="name"
              :filterable="false"
            ></v-select>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('message.Сменить_пароль')">
          <b-form-group
            :label="$t('message.Новый_пароль') + ':'"
            label-for="newpassword"
          >
            <b-form-input
              id="newpassword"
              type="password"
              v-model="newPassword"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            :label="$t('message.Повторите_пароль') + ':'"
            label-for="repeatpassword"
          >
            <b-form-input
              id="repeatpassword"
              type="password"
              v-model="repeatPassword"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="">
            <b-button @click.stop="changePassword()">{{
              $t("message.Сменить_пароль")
            }}</b-button>
          </b-form-group>
        </b-tab>

        <b-tab :title="$t('message.Контакты')">
          <b-form-group label="Name:" label-for="Contact_name">
            <b-form-input
              id="Contact_name"
              type="text"
              v-model="model.name"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Email:" label-for="Contact_email">
            <b-form-input
              id="Contact_email"
              type="text"
              v-model="model.email"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Phone:" label-for="Contact_phone">
            <b-form-input
              id="Contact_phone"
              type="text"
              v-model="model.phone"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="Contact_address:" label-for="Contact_address">
            <b-form-input
              id="Contact_address"
              type="text"
              v-model="model.address"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="url:" label-for="Contact_url">
            <b-form-input
              id="Contact_url"
              type="text"
              v-model="model.url"
              required
            >
            </b-form-input>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name: "UserForm",
  props: ["model"],
  data() {
    return {
      roles: [],
      newPassword: "",
      repeatPassword: ""
    };
  },
  created: function() {
    console.log("created");

    let roles = this.$noname.get("roles");

    roles
      .then(data => {
        this.roles = data.data.items;
        console.log("roles: " + this.roles);
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Ошибка_получения_данных") + ":<br>" + error,
          type: "error"
        });
      });
  },
  methods: {
    changePassword: function() {
      if (this.newPassword == "") {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Пароль_не_может_быть_пустым"),
          type: "error"
        });
        return true;
      }
      if (this.newPassword != this.repeatPassword) {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Пароли_не_совпадают"),
          type: "error"
        });
        return true;
      }

      let promise = this.$noname.patchChild(
        "users",
        this.model.id,
        "password",
        { password: this.newPassword }
      );

      promise
        .then(data => {
          Vue.notify({
            group: "notify",
            text: this.$i18n.t("message.Пароль_успешно_изменен"),
            type: "success"
          });
        })
        .catch(this.$noname.HandleError);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/UserForm.vue